import { useCallback, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { ShowToastError } from '../../components/toast/Toast';
import Header from '../Home/Header';

import DateFormat from '../../utils/DateFormat';
import ToastQuestion, { IToastQuestionParams } from '../../components/toast/ToastQuestion';
import RedirecionamentoSvc, { IRedirecionamentosResponse } from '../../services/RedirecionamentoSvc';

function ListaRedirecionamento() {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [redirecionamentos, setRedirecionamentos] = useState<IRedirecionamentosResponse[]>([]);
    const [question, setQuestion] = useState<IToastQuestionParams | null>(null);

    function irParaForm(id: string) {
        navigate(`/cadastroRedirecionamento/${id}`);
    }

    function verForm(origem: string) {
        console.log(origem);
        window.open(`${process.env.REACT_APP_URL_SITE}/${origem}`, '_blank');
    }

    async function deleteForm(item: IRedirecionamentosResponse) {
        try {
            await RedirecionamentoSvc.deleteRedirecionamento(item.id);
            obterRedirecionamento();
        } catch (error) {
            setLoading(false);
            if (!!error?.response) {
                ShowToastError(error?.response?.data?.error?.message);
            } else {
                ShowToastError(error?.message ?? 'Sem conexão com internet');
            }
        }
    }

    function confirmacaoDelete(item: IRedirecionamentosResponse) {
        setQuestion({
            title: 'Confirmação',
            description: `Deseja realmente excluir este redirecionamento? (${item.origem})`,
            onOk: () => {
                setQuestion(null);
                deleteForm(item);
            },
            onClose: () => setQuestion(null),
        });
    }

    const obterRedirecionamento = useCallback(async () => {
        try {
            setLoading(true);
            const response = await RedirecionamentoSvc.obterRedirecionamentos();
            setRedirecionamentos(response);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            if (!!error?.response) {
                ShowToastError(error?.response?.data?.error?.message);
            } else {
                ShowToastError(error?.message ?? 'Sem conexão com internet');
            }
        }
    }, []);

    useEffect(() => {
        obterRedirecionamento();
    }, [obterRedirecionamento]);

    return (
        <>
            <Header />
            <div className="box-page">
                <div className="box-page-header">
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h2 className="text-page-title text-white">Cadastro Redirecionamentos</h2>
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={obterRedirecionamento}
                            style={{ marginLeft: '15px' }}
                        >
                            Consultar
                        </button>
                    </div>
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => irParaForm('novo')}>
                        Novo redirecionamento
                    </button>
                </div>
                <div className="box-page-content">
                    {loading ? (
                        <div className="flex-center">
                            <div className="spinner-border text-light" role="status" style={{ marginRight: 10 }} />
                        </div>
                    ) : (
                        <Table
                            striped
                            bordered
                            hover
                            variant="dark"
                            style={{ overflowX: 'auto', whiteSpace: 'nowrap', display: 'block', width: '100%' }}
                        >
                            <tbody style={{ display: 'table', width: '100%' }}>
                                <tr>
                                    <th>Origem</th>
                                    <th>Destino</th>
                                    <th>Data Cadastro</th>
                                    <th></th>
                                </tr>
                                {redirecionamentos.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item?.origem ?? ''}</td>
                                        <td>{item?.destino ?? ''}</td>
                                        <td>{DateFormat.formatarDataHora(item?.criadoEm ?? null)}</td>
                                        <td>
                                            <div className="btn-table-edit">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => verForm(item?.origem)}
                                                >
                                                    Testar
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary btn-sm"
                                                    onClick={() => irParaForm(item?.id)}
                                                >
                                                    Editar
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => confirmacaoDelete(item)}
                                                >
                                                    Excluir
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </div>
            </div>
            {!!question && <ToastQuestion info={question} />}
        </>
    );
}

export default ListaRedirecionamento;
